export function firstFocusableKeyHandler(renderRoot, selector) {
  var el = renderRoot.querySelector(selector);
  el.focus();
}
export function lastFocusableKeyHandler(e, focusHandler) {
  var tabKey = 'Tab';
  if (!e.shiftKey && e.key === tabKey) {
    focusHandler();
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}
